module.exports = __webpack_public_path__ + "7f25efabf27f3fd82ec38a12477a4d46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/feed-default.png
// module id = 1805
// module chunks = 1